<template>
  <div class="like-detail-container">
    <p class="title-con">
      <span class="title">“喜欢”明细</span>
      <span class="num">共{{total}}条记录</span>
    </p>
    <van-list v-model="isLoading" :finished="isFinished" finished-text="没有更多了" @load="fetchData" class="list">
      <li class="item" v-for="(item, index) in list" :key="index">
        <p class="name">{{item.detail}}</p>
        <p class="sub">
          <span class="left">剩余{{item.remain}}个</span>
          <span class="date">{{item.createTime | formatTime}}</span>
        </p>
      </li>
    </van-list>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'LikeDetail',
  data () {
    return {
      isLoading: false,
      isFinished: false,
      currentPage: 1,
      pageSize: 20,
      list: [],
      total: 0
    }
  },
  computed: {
    ...mapGetters({
      userId: 'userId'
    })
  },
  methods: {

    fetchData () {
      let flag = setInterval(() => {
        if (this.userId) {
          clearInterval(flag)
          this.isLoading = true
          this.$http('/api/member/like/bill', {
            currentPage: this.currentPage,
            pageSize: this.pageSize,
            actionType: 20
          }, 'get').then(res => {
            this.isLoading = false
            if (res.code === '0000' && res.data) {
              const data = res.data
              if (this.currentPage === 1) {
                this.list = data.list
              } else {
                this.list = [...this.list, ...data.list]
              }
              this.total = data.total
              if (this.list.length >= data.total || !this.userId) {
                this.isFinished = true
              }
              this.currentPage++
            } else {
              this.isFinished = true
              this.$toast(res.msg)
            }
          }, err => {
            this.isFinished = true
            this.isLoading = false
            this.$toast(err)
          })
        }
      }, 300)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/constant.scss";
.like-detail-container {
  >>> .van-list__finished-text {
    margin-top: 30px;
  }
  .title-con {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: 20px 40px;
    border-bottom: 1px solid #e4e4e4;
  }
  .title {
    font-size: 42px;
    line-height: 60px;
    font-weight: bold;
  }
  .num {
    color: #9b9b9b;
  }
  .list {
    padding-left: 40px;
  }
  .item {
    padding: 32px 40px 5px 0;
    .name {
      color: #38383c;
      font-size: 32px;
      line-height: 48px;
    }
    .sub {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .date,
    .left {
      color: #9b9b9b;
      font-size: 20px;
      line-height: 28px;
    }
    & + .item {
      border-top: 1px solid #e5e5e5;
    }
  }
}
</style>
